export default {
  assign_to_myself: 'Assign to myself',
  reassign: 'Assign to user',
  modal: {
    title: 'Reassign chat with {numbers}',
    description: 'Select the user to assign the conversation',
    other_options: 'Other options',
    unassigned_title: 'Unassigned',
    unassigned_description: 'Any other user can continue to chat',
  },
  with: {
    title: 'with',
    me: 'Me',
  },
}
